<div class="w-100-p">
    <mat-form-field  appearance="outline" color="primary"
    [floatLabel]='formControl.value ? "always" : " "'
    class="w-100-p pb-0 mb-0 w-100-p">
        <mat-label>{{to.label}}</mat-label>
        <ng-select ngSelectMat 
        matInput
        [items]="to.options || items" 
        appendTo="body"
        [loading]="loading"
        [multiple]="to.multiple"
        [bindLabel]="to.bindLabel"
        [formlyAttributes]="field"
        [formControl]="formControl"
        [placeholder]="to.placeholder"
        [bindValue]="to.bindValue || value"

        [markFirst]="to.markFirst"
        [loadingText]="to.loadingText"
        [hideSelected]="to.hideSelected"
        [searchable]="to.searchable"
        [closeOnSelect]="to.closeOnSelect"
        (search)="getOptions($event)"
        notFoundText="No result matched your search"
        >
        </ng-select>
    </mat-form-field>
    <ng-container 
    *ngIf="formControl.touched && formControl.invalid">
        <ul class="list-inline text-danger err-cont"
        style="margin-top: -2.25rem;">
            <li class="list-inline-item text-danger"
            *ngIf="formControl.errors?.required">
                This field is required,
            </li>
        </ul>
    </ng-container>
    <p class="text-muted small"
    *ngIf="to.helpText"
    style="padding-top:0.6rem;">
        {{to.helpText}}
    </p>
</div>